import {InfiniteData, useMutation, useQueryClient} from '@tanstack/react-query'
import {MUTATION_KEYS, QUERY_KEYS} from './keys'
import {sendSeenNotifications} from '../services/notifications.http'
import {NotificationsType} from '../types'

export const useSendSeenNotifications = () => {
    const queryClient = useQueryClient()
    return useMutation({
        mutationKey: [MUTATION_KEYS.notifications_seen],
        mutationFn: sendSeenNotifications,
        onSuccess: () => {
            queryClient.setQueryData(
                [QUERY_KEYS.notificationsHistory],
                (oldData: InfiniteData<NotificationsType[]>) => {
                    return {
                        ...oldData,
                        pages: oldData.pages.map(page =>
                            page.map(notification =>
                                notification.seenAt ? notification : {...notification, seenAt: new Date()}
                            )
                        )
                    }
                }
            )
            queryClient.setQueryData([QUERY_KEYS.notificationUnreadCount], () => ({count: 0}))
        }
    })
}
